export const TASK_TYPE_LABELS: Record<string, string> = {
  website: 'New Page',
  'change-text-on-my-website': 'Change Text',
  'change-image-on-my-website': 'Change Image',
  'add-a-new-link': 'New Link',
  'add-a-new-page': 'Add Page',
  'create-new-blog-post': 'Create Blog Post',
  'request-new-functionality': 'Request New Functionality',
  'report-a-bug': 'Report a Bug',
};

export const TASK_TYPE_OPTIONS = [
  { value: 'change-text-on-my-website', label: TASK_TYPE_LABELS['change-text-on-my-website'] },
  { value: 'change-image-on-my-website', label: TASK_TYPE_LABELS['change-image-on-my-website'] },
  { value: 'add-a-new-page', label: TASK_TYPE_LABELS['add-a-new-page'] },
  { value: 'create-new-blog-post', label: TASK_TYPE_LABELS['create-new-blog-post'] },
  { value: 'add-a-new-link', label: TASK_TYPE_LABELS['add-a-new-link'] },
  { value: 'request-new-functionality', label: TASK_TYPE_LABELS['request-new-functionality'] },
  { value: 'report-a-bug', label: TASK_TYPE_LABELS['report-a-bug'] },
];

export const formatTaskTypeLabel = (taskType?: string | null): string => {
  const normalized = String(taskType || '').trim();
  if (!normalized) return 'Unknown';
  if (TASK_TYPE_LABELS[normalized]) return TASK_TYPE_LABELS[normalized];

  return normalized
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ') || 'Unknown';
};
